import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const FormFolder = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='FormFolder' {...props}>
    <polygon fill='none' stroke='#000' strokeWidth='2' points='6 18 6 6 10.8 6 12.6 8.4 18 8.4 18 18' />
  </StyledIcon>
);
